import { render, staticRenderFns } from "./PricingCards.vue?vue&type=template&id=054b1203&scoped=true"
import script from "./PricingCards.vue?vue&type=script&lang=js"
export * from "./PricingCards.vue?vue&type=script&lang=js"
import style0 from "./PricingCards.vue?vue&type=style&index=0&id=054b1203&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054b1203",
  null
  
)

export default component.exports